import { hasScrollBar } from '../helpers/Helpers';

class amrModal {
    constructor(modal){
        this.modal = $(modal);
        this.assignEvents();
    }
    handleShow(e){
        if (hasScrollBar()) {
            $('body').css("padding-right", "12px");
            $('.navbar').css("padding-right", "12px");
            e.target.style.paddingRight = "12px";
        }
    }
    handleHide(e) {
        if (hasScrollBar()) {
            $('body').css("padding-right", "");
            $('.navbar').css("padding-right", "");
            e.target.style.paddingRight = "";
        }
    }
    assignEvents(){
        this.modal.on('show.bs.modal', this.handleShow);
        this.modal.on('hidden.bs.modal', this.handleHide);
    }
}

export default amrModal;